import PaymentsDialog from './PaymentsDialog'

export * from './PaymentsDialog'
export default PaymentsDialog
